
import { Vue, Options, prop } from "vue-class-component";
import { FlightData } from '@/domain/entities/CargoV2';
import moment from 'moment';
import formatTimeCustom from '@/app/infrastructures/misc/common-library/FormatTimeCustom';
import { AccountController } from "@/app/ui/controllers/AccountController";

moment.locale(
  AccountController.accountData.countryCode === "my"
    ? "en"
    : AccountController.accountData.countryCode || "id"
);

class Props {
  data = prop<FlightData>({
    required: true
  });
}

@Options({})
class CargoV2PlaneTrack extends Vue.with(Props) {
  isOpenDetail = false;

  openDetail() {
    this.isOpenDetail = !this.isOpenDetail;
  }

  get isGridLayout() {
    return this.data.itineraries.length > 4;
  }

  get transitGridRows() {
    const itineraries = this.data.itineraries;
    const items = [
      ...itineraries.map((itinerary, index) => ({
        isDestination: false,
        isEmpty: false,
        itinerary,
        index,
      })),
      {
        isDestination: true,
        isEmpty: false,
        itinerary: itineraries[itineraries.length - 1],
        index: -1,
      },
    ];
    const rows = [];
    const firstRow = items.slice(0, 4) as typeof items;
    while (firstRow.length < 4) {
      firstRow.push({ isEmpty: true, isDestination: false, itinerary: null as any, index: -1 });
    }
    rows.push(firstRow);
    for (let i = 4; i < items.length; i += 3) {
      const row = items.slice(i, i + 3) as typeof items;
      while (row.length < 3) {
        row.push({ isEmpty: true, isDestination: false, itinerary: null as any, index: -1 });
      }
      rows.push(row);
    }
    return rows;
  }

  mapLogoPlaneLabel(prefix: string) {
    if (prefix.startsWith("JT")) {
      return "badge-lion-air";
    } else if (prefix.startsWith("ID")) {
      return "badge-batik-air";
    } else if (prefix.startsWith("IU")) {
      return "badge-super-jet-air";
    } else if (prefix.startsWith("IW")) {
      return "badge-wings-air";
    }
    return "";
  }

  formatFlightDuration(departure: string, arrival: string): string {
    const diffMs = new Date(arrival).getTime() - new Date(departure).getTime();

    if (diffMs <= 0) return this.$t("cargoV2.components.manualInput.flightDuration.minutes", { count: 0 });

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) {
      return this.$t("cargoV2.components.manualInput.flightDuration.minutes", { count: totalMinutes });
    }

    if (minutes === 0) {
      return this.$t("cargoV2.components.manualInput.flightDuration.hours", { count: hours });
    }

    return this.$t("cargoV2.components.manualInput.flightDuration.hoursMinutes", {
      hours,
      minutes
    });
  }

  formatShortDate(d: string) {
    return moment(d).format("ddd, DD MMM");
  }
  formatDateTransit(date: string) {
    return date ? moment(date).format("DD MMM") : "";
  }
  formatTime(d: string) {
    return formatTimeCustom({ date: d, isSecond: false });
  }
}
export default CargoV2PlaneTrack;
